import { ThemeFamilies } from './types';
var getBadge = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.primary,
            text: colors.white,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DEFAULT] = {
            main: colors.surface4,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.INFO] = {
            main: colors.surfaceFamilies.highlightsHover,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.SUCCESS] = {
            main: colors.decorative.successHover,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.WARNING] = {
            main: colors.warning2,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.ERROR] = {
            main: colors.redNotice,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DECORATIVE_BLUE] = {
            main: colors.decorative.primaryPressed,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DECORATIVE_PURPLE] = {
            main: colors.secondaryHover,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DECORATIVE_RED_LIGHT] = {
            main: colors.decorative.error,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DECORATIVE_PINK] = {
            main: colors.decorative.thirdaryHover,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DECORATIVE_TURQUOISE] = {
            main: colors.decorative.info,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.DECORATIVE_BEIGE] = {
            main: colors.surfaceFamilies.warningHover,
            text: colors.secondaryText,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a[ThemeFamilies.GREY] = {
            main: colors.surface4,
            text: colors.grey.grey40,
            disabled: colors.surface4,
            disabledText: colors.grey.grey40,
        },
        _a);
};
export default getBadge;
